import { Box } from "@mui/material";
import { DayPicker, DateRange } from "react-day-picker";
import { ptBR } from "date-fns/locale";
import "react-day-picker/dist/style.css";

interface RangeCalendarProps {
	from: Date | undefined;
	to: Date | undefined;
	onChange: (range: DateRange | undefined) => void;
}

export default function RangeCalendar({
	from,
	to,
	onChange,
}: RangeCalendarProps) {
	return (
		<Box
			sx={(theme) => ({
				"& .rdp": {
					"--rdp-accent-color": theme.palette.success.main,
					"--rdp-background-color": "rgba(101, 179, 44, 0.15)",
				},
			})}
		>
			<DayPicker
				mode="range"
				locale={ptBR}
				selected={{ from, to }}
				onSelect={onChange}
			/>
		</Box>
	);
}
